module.exports = __webpack_public_path__ + "media/images/webpage/hotels/staff_members/user-5d7b60fcb853b3e04d79fc9e92b7a9c2.webp";